import React from 'react'
import { useValues } from 'kea'

import I18n from 'lib/i18n'

import sceneLogic from '~/scenes/pages/request/logic'

const reorderTimesOfDay = availableTimes => {
  const timeOfDayOrder = ['morning', 'afternoon', 'evening']
  return timeOfDayOrder.filter(timeOfDay => availableTimes.includes(timeOfDay))
}

const ALL_DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

const groupedAvailability = availability => {
  const groups = {}
  availability.forEach(availability => {
    let group = availability.split('_')

    groups[group[0]] = groups[group[0]] ? groups[group[0]].concat([group[1]]) : [group[1]]
  })

  return (
    <div className='grouped-availability'>
      {ALL_DAYS.filter(day => groups[day]).map(day => (
        <div key={day}>
          {I18n.t(`weekday_long.${day}`)}{' '}
          {reorderTimesOfDay(groups[day])
            .map(timeOfDay => I18n.t(`react.request.availability.option_${timeOfDay}`).toLowerCase())
            .join(', ')}
        </div>
      ))}
    </div>
  )
}

const Summary = () => {
  const { category, location, studentAge, startTime, availability, availabilityFlexible, frequency, locationType } =
    useValues(sceneLogic)

  return (
    <table className='request-data'>
      <tbody>
        {category && (
          <tr>
            <th>{I18n.t('react.request.category.summary')}</th>
            <td>{category}</td>
          </tr>
        )}
        {location && (
          <tr>
            <th>{I18n.t('react.request.location.summary')}</th>
            <td>{location}</td>
          </tr>
        )}
        {studentAge && (
          <tr>
            <th>{I18n.t('react.request.student_age.summary')}</th>
            <td>{I18n.t(`react.search.filters.age.${studentAge}`)}</td>
          </tr>
        )}
        {startTime && (
          <tr>
            <th>{I18n.t('react.request.start_time.summary')}</th>
            <td>{I18n.t(`activerecord.enums.message.start_time.${startTime}`)}</td>
          </tr>
        )}
        {availability && availability.length > 0 && (
          <tr>
            <th>{I18n.t('react.request.availability.summary')}</th>
            <td>{groupedAvailability(availability)}</td>
          </tr>
        )}
        {availabilityFlexible && (
          <tr>
            <th>{I18n.t('react.request.availability.summary')}</th>
            <td>{I18n.t('react.request.availability.flexible')}</td>
          </tr>
        )}
        {frequency && (
          <tr>
            <th>{I18n.t('react.request.frequency.summary')}</th>
            <td>{I18n.t(`react.request.frequency.option_${frequency}`)}</td>
          </tr>
        )}
        {locationType && (
          <tr>
            <th>{I18n.t('react.request.location_type.summary')}</th>
            <td>{I18n.t(`react.search.filters.location.${locationType}`)}</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export default Summary
